import { Middleware, MiddlewareAPI } from 'redux';
import { isAction } from '@reduxjs/toolkit';

import { isRemoteAction } from '@paragon/sync-client';

import { RootState } from '..';
import { synchronizeLocalStationAfterServerUpdate } from '../actions/stationActions';
import { ReduxDispatch } from '../actions/thunkActions';
import { loadStation } from '../slices/stationsSlice';

export const stationSynchronizationMiddleware: Middleware<{}, RootState, ReduxDispatch> =
  (store: MiddlewareAPI<ReduxDispatch, RootState>) => (next) => (action) => {
    if (!isAction(action)) {
      return next(action);
    }

    const oldState = store.getState();

    const result = next(action);

    if (!isRemoteAction(action) || !loadStation.match(action)) {
      return result;
    }

    const stationGuid = action.payload.station.guid;

    let oldComponentDesignGuidsInStation: string[] = [];
    const newComponentDesignGuidsInStation = Object.keys(action.payload.station.componentDesigns);

    const { openContext } = oldState.application;
    const isInRelevantStationContext =
      (openContext?.type === 'station' || openContext?.type === 'schedule-station') &&
      openContext.stationGuid === stationGuid;

    if (isInRelevantStationContext) {
      oldComponentDesignGuidsInStation = Object.keys(oldState.stations[openContext.stationGuid].componentDesigns);
    }

    store.dispatch(
      synchronizeLocalStationAfterServerUpdate(
        isInRelevantStationContext,
        action.payload.station,
        oldComponentDesignGuidsInStation,
        newComponentDesignGuidsInStation,
      ),
    );

    return result;
  };
